import { ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from 'firebase/app-check';

export const createAppCheckProvider = (siteKey, provider = 'recaptcha-v3') => {
  if (provider === 'recaptcha-enterprise') return new ReCaptchaEnterpriseProvider(siteKey);
  if (provider === 'recaptcha-v3') return new ReCaptchaV3Provider(siteKey);
  throw new Error('Unsupported Firebase App Check provider.');
};
